<template>
  <router-view />
</template>

<script>
export default {
  name: 'UserSA',
}
</script>
